const ShopReturnMobileWarehouseIconMenu = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="32"
        height="32"
        rx="6.64935"
        fill="url(#paint0_linear_2692_11613)"
        fill-opacity="0.1"
      />
      <g clip-path="url(#clip0_2692_11613)">
        <path
          d="M23.7975 13.9262L16.7662 9.0825C16.6062 8.9725 16.395 8.9725 16.2344 9.0825L9.20312 13.9262C9.07562 14.0138 9 14.1581 9 14.3125V23.375C9 23.72 9.28 24 9.625 24H10.875V16.5C10.875 16.155 11.155 15.875 11.5 15.875H21.5C21.845 15.875 22.125 16.155 22.125 16.5V24H23.375C23.72 24 24 23.72 24 23.375V14.3125C24 14.1581 23.9244 14.0138 23.7975 13.9262Z"
          fill="#052351"
        />
        <path
          d="M14.7812 20.875V21.3438C14.7812 21.6025 14.5712 21.8125 14.3125 21.8125C14.0538 21.8125 13.8438 21.6025 13.8438 21.3438V20.875H12.75C12.5775 20.875 12.4375 21.015 12.4375 21.1875V23.6875C12.4375 23.86 12.5775 24 12.75 24H15.875C16.0475 24 16.1875 23.86 16.1875 23.6875V21.1875C16.1875 21.015 16.0475 20.875 15.875 20.875H14.7812Z"
          fill="#052351"
        />
        <path
          d="M19.1562 20.875V21.3438C19.1562 21.6025 18.9462 21.8125 18.6875 21.8125C18.4288 21.8125 18.2188 21.6025 18.2188 21.3438V20.875H17.125C16.9525 20.875 16.8125 21.015 16.8125 21.1875V23.6875C16.8125 23.86 16.9525 24 17.125 24H20.25C20.4225 24 20.5625 23.86 20.5625 23.6875V21.1875C20.5625 21.015 20.4225 20.875 20.25 20.875H19.1562Z"
          fill="#052351"
        />
        <path
          d="M16.9688 17.125V17.5938C16.9688 17.8525 16.7587 18.0625 16.5 18.0625C16.2413 18.0625 16.0312 17.8525 16.0312 17.5938V17.125H14.9375C14.765 17.125 14.625 17.265 14.625 17.4375V19.9375C14.625 20.11 14.765 20.25 14.9375 20.25H18.0625C18.235 20.25 18.375 20.11 18.375 19.9375V17.4375C18.375 17.265 18.235 17.125 18.0625 17.125H16.9688Z"
          fill="#052351"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2692_11613"
          x1="15.7922"
          y1="0"
          x2="15.7922"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0062FF" />
          <stop offset="1" stop-color="#004BC2" />
        </linearGradient>
        <clipPath id="clip0_2692_11613">
          <rect width="15" height="15" fill="white" transform="translate(9 9)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ShopReturnMobileWarehouseIconMenu
